<template>
  <div class="widget-list">
    <p class="bold">
      Please review the below points to continue with this claim.
    </p>

    <ul class="widget-list-content list-unstyled">
      <li class="widget-list-item widget-list-item-green">
        <span class="widget-list-item-check">
          <div class="form-check form-check-inline">
            <input
              v-model="checklist.receipt"
              class="form-check-input"
              type="checkbox"
              value=""
            />
          </div>
        </span>
        <span class="widget-list-item-description">
          <span
            class="widget-list-item-description-title"
            :class="{ strikethrough: checklist.receipt }"
          >
            Does the provided Fuel Type, Litres and Value match those on the
            provided receipt?
          </span>
          <span
            class="widget-list-item-description-subtitle text-danger"
            v-if="!checklist.receipt"
          >
            If the fuel type, value or litres do not match you must contact site
            to confirm the details of the event. Head to the Management tab to
            send an issue email to site!
          </span>
        </span>
      </li>
      <li class="widget-list-item widget-list-item-green">
        <span class="widget-list-item-check">
          <div class="form-check form-check-inline">
            <input
              v-model="checklist.image"
              class="form-check-input"
              type="checkbox"
              value=""
            />
          </div>
        </span>
        <span class="widget-list-item-description">
          <span
            class="widget-list-item-description-title"
            :class="{ strikethrough: checklist.image }"
          >
            Does the provided registration match the one in the provided image?
            (If no image, you may check this box)
          </span>
          <span
            class="widget-list-item-description-subtitle text-danger"
            v-if="!checklist.image"
          >
            If the registration provided does not match that of the vehicle in
            the image then you must contact site and ask for confirmation of the
            registration plate.
          </span>
        </span>
      </li>
      <li class="widget-list-item widget-list-item-green">
        <span class="widget-list-item-check">
          <div class="form-check form-check-inline">
            <input
              v-model="checklist.mmc"
              class="form-check-input"
              type="checkbox"
              value=""
            />
          </div>
        </span>
        <span class="widget-list-item-description">
          <span
            class="widget-list-item-description-title"
            :class="{ strikethrough: checklist.mmc }"
          >
            Does the auto-generated make, model and colour match the vehicle in
            the image? (If no image, you may check this box)
          </span>
          <span
            class="widget-list-item-description-subtitle text-danger"
            v-if="!checklist.mmc"
          >
            If the make, model and colour do not match it may be that the
            vehicle has a tampered or cloned plate. If you cannot legitimately
            identify the correct plate you must cancel the claim!
          </span>
        </span>
      </li>
      <li class="widget-list-item widget-list-item-green">
        <span class="widget-list-item-check">
          <div class="form-check form-check-inline">
            <input
              v-model="checklist.fuel"
              class="form-check-input"
              type="checkbox"
              value=""
            />
          </div>
        </span>
        <span class="widget-list-item-description">
          <span
            class="widget-list-item-description-title"
            :class="{ strikethrough: checklist.fuel }"
          >
            Does the provided fuel type match that of the provided vehicle?
          </span>
          <span
            class="widget-list-item-description-subtitle text-danger"
            v-if="!checklist.fuel"
          >
            If the provided fuel types do not match you must contact site and
            ask for confirmation. It could be that the customer filled up a fuel
            canister. Any confirmation should be uploaded as evidence in the
            Uploaded Evidence tab.
          </span>
        </span>
      </li>
    </ul>

    <p
      v-show="checklist.receipt && checklist.image && checklist.mmc"
      class="bold"
    >
      If you are happy to continue with this claim, please generate the enquiry
      form below. Once the enquiry form has been posted, you may mark this claim
      as at the DVLA.
    </p>
    <p class="tx-info" v-show="downloading">
      Currently generating DVLA Enquiry Form, please wait...
    </p>
    <button
      v-show="
        checklist.receipt && checklist.image && checklist.mmc && !downloading
      "
      class="btn btn-primary pd-x-25 pd-y-11 tx-uppercase bold tx-spacing-6 tx-12"
      @click="download"
    >
      Generate DVLA Enquiry
    </button>
    <button
      v-show="
        checklist.receipt && checklist.image && checklist.mmc && !downloading
      "
      class="btn btn-success pd-x-25 pd-y-11 tx-uppercase bold tx-spacing-6 tx-12 m-l-sm"
      @click="updateStatus"
    >
      Mark as At DVLA
    </button>
  </div>
</template>

<script>
export default {
  name: "DriveoffPending",
  props: {
    claim: Object,
    client_id: Number | String,
  },
  data() {
    return {
      checklist: {
        receipt: false,
        image: false,
        mmc: false,
        fuel: false,
      },
      downloading: false,
    };
  },
  mounted() {
    if (this.claim.fuel === this.claim.fuelType) {
      this.checklist.fuel = true;
    }
  },
};
</script>

<style scoped>
.strikethrough {
  text-decoration: line-through !important;
}
.widget-list
  .widget-list-content
  .widget-list-item
  .widget-list-item-description
  .widget-list-item-description-subtitle {
  white-space: none !important;
}
</style>
